import e from "@dialpad/dialtone-tokens/layered/themes/tokens-107-colors.css?inline";
//#region themes/107.js
var t = { brand: {
	css: e,
	name: "107"
} };
//#endregion
export { t as default };
